module.exports = __webpack_public_path__ + "static/img/banner2View.e21f19ee.jpg";